export default __webpack_public_path__ + "static/media/inward.06cf6474.png";